export const abs = (x) => Math.abs(x);
export const min = (...values) => Math.min(...values);
export const max = (...values) => Math.max(...values);
export const ceil = (x) => Math.ceil(x);
export const round = (x) => Math.round(x);
export const floor = (x) => Math.floor(x);
